import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { APP_NAME } from "../constants";

export const JumpMenuBranding: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ px: 2, py: 1, borderTop: (theme) => `1px solid ${theme.palette.divider}`, textAlign: "center" }}>
      <Typography variant="caption" color="text.secondary">
        {t("jumpMenu.footer_brand", {
          appName: APP_NAME,
          defaultValue: "{{appName}}™ is designed, built, and backed by Juan Burciaga.",
        })}
      </Typography>
    </Box>
  );
};

export default JumpMenuBranding;
